const hasText = (value) => String(value ?? '').trim().length > 0;

/**
 * Проверяет именно подсказку DaData для выездного адреса.
 * Улица и квартира не обязательны: в небольших населённых пунктах улицы
 * может не быть в официальном адресе.
 */
export const getServiceAddressValidation = (suggestion) => {
  const data = suggestion?.data || suggestion || {};
  // Уже сохранённый адрес клиента не является новой подсказкой DaData:
  // не блокируем старые записи, даже если в них нет разложенных частей адреса.
  if (data.id !== null && data.id !== undefined && String(data.id).trim() !== '') {
    return { isComplete: true, hasLocality: true, hasHouse: true, hasStreet: true, locality: null, house: null };
  }
  const locality = String(data.city || data.settlement || '').trim() || null;
  const house = String(data.house || '').trim() || null;
  const hasLocality = Boolean(locality);
  const hasHouse = hasText(data.house);
  const hasStreet = hasText(data.street);

  return {
    isComplete: hasLocality && hasHouse,
    hasLocality,
    hasHouse,
    hasStreet,
    locality,
    house,
  };
};

export const isCompleteServiceAddress = (suggestion) => (
  getServiceAddressValidation(suggestion).isComplete
);

export const incompleteServiceAddressMessage = () => (
  'Для выезда выберите адрес с населённым пунктом и номером дома'
);
